export enum RosterView {
  MY_ROSTER = 1,
  BROWSE = 2,
  COMPETITION_DETAIL = 3,
  DETAIL_CURRENT = 4,
  DETAIL_ARCHIVE = 5,
  DETAIL_HISTORY = 6,
  DETAIL_COMPETITIONS = 7,
  STATISTICS_CATEGORIES = 8,
  STATISTICS_CLUBS = 9,
  STATISTICS_LETTERS = 10,
  STATISTICS_COMPETITIONS = 11,
  STATISTICS_REGIONS = 12,
  STATISTICS_COMPLETE = 13,
  DETAIL_EDIT = 14,
}
